// removed by extract-text-webpack-plugin
module.exports = {"twoFactor":"twoFactor___2TMxX","twoFactorDiv":"twoFactorDiv___3TTmN","twoFactorTitle":"twoFactorTitle___2D7vX","title":"title___1qhlS","codePart":"codePart___3Kdi0","codePartInput":"codePartInput___1Tlpt","btnWidth":"btnWidth___BrX-N","getCodeBtn":"getCodeBtn___2q5Qp","checkCodeBtn":"checkCodeBtn___3WG7t"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Verification/index.less
// module id = 355
// module chunks = 0